module.exports = __webpack_public_path__ + "img/icon_3_14.cf53f721.png";